// extracted by mini-css-extract-plugin
module.exports = {"arrowButton":"NextArrow_arrowButton__3RuLe"};